import { Navigate } from 'react-router-dom'
import { isPinAuthGatePending } from '../../../util/pinBrowserFlags'
import { isAuthenticated } from '../../../util/authentication'
import ROUTES from '../../../assets/routes'

const AuthCheckerRoute = ({ children }: any) => {
    let authenticated: boolean = isAuthenticated()

    if (authenticated && isPinAuthGatePending()) {
        return children
    }

    if (authenticated) {
        const prevUrl = window.sessionStorage.getItem('prevUrl')
        if (prevUrl) {
            return <Navigate to={prevUrl} replace />
        }
        return <Navigate to={ROUTES.base} replace />
    }
    return children

}

export default AuthCheckerRoute